import { NotificationBannerType } from "Contexts/notification-banners-context";
import styles from "../notification-banners.css";

export const getTypeClass = (type: NotificationBannerType) => {
    switch (type) {
        case NotificationBannerType.Information:
            return styles.information;

        case NotificationBannerType.Success:
            return styles.success;

        case NotificationBannerType.Attention:
            return styles.attention;

        case NotificationBannerType.Error:
            return styles.error;

        default:
            throw new Error("Invalid NotificationBannerType");
    }
};
